import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import {
  CreatePurchaseOrderInput,
  CreatePurchaseOrderMutation,
} from '@/gql/graphql';

const CREATE_PURCHASE_ORDER = graphql(`
  mutation CreatePurchaseOrder($input: CreatePurchaseOrderInput!) {
    createPurchaseOrder(input: $input) {
      id
    }
  }
`);

const useCreatePurchaseOrder = (
  options?: UseMutationOptions<
    CreatePurchaseOrderMutation,
    unknown,
    CreatePurchaseOrderInput
  >
) => {
  return useMutation({
    mutationFn: (input) => gqlClient.request(CREATE_PURCHASE_ORDER, { input }),
    ...options,
  });
};

export default useCreatePurchaseOrder;
